import React from "react";
import { Link } from "react-router-dom";
import styles from "./CTASection.module.css";
import { Container } from "../../common/Container";
import { ctaData } from "../../../data/sharedSpendData";

export const CTASection: React.FC = () => (
  <section className={styles.section}>
    <Container>
      <div className={styles.card}>
        <div className={styles.glow} />
        <h2 className={styles.headline}>{ctaData.headline}</h2>
        <p className={styles.subheadline}>{ctaData.subheadline}</p>
        <Link to={ctaData.waitlistUrl} className={styles.cta}>
          {ctaData.cta}
        </Link>
      </div>
    </Container>
  </section>
);
